<template>
  <v-layout
    align-center
    class="word-tag-container"
    :class="selected && `word-tag-container-${color}`"
    @click="$emit('click')"
  >
    <span class="word-tag-dot" :class="selected && 'word-tag-dot-selected'"></span>
    <span
      class="word-tag-text-container"
      :class="selected && `word-tag-text-container-${color}`"
    >
      <AnimatedText v-if="animated" class="word-tag-text" :text="text[0]"></AnimatedText>
      {{ !animated ? text[0] : '' }}
    </span>
    <template v-if="text.length > 1">
      <template v-for="(word, index) in text.slice(1)">
        <GroupingIcon :is-collapsing="false" :key="word + generateUuid()" @click="$emit('handleSplitTerms', index)"></GroupingIcon>
        <span
          class="word-tag-text-container"
          :class="selected && `word-tag-text-container-${color}`"
          :key="word + generateUuid()"
        >
          <AnimatedText v-if="animated" class="word-tag-text" :text="word"></AnimatedText>
          {{ !animated ? word : '' }}
        </span>
      </template>
    </template>
  </v-layout>
</template>

<script>
import '../../../../style/_variables.scss'
import AnimatedText from '../AnimatedText.vue'
import GroupingIcon from './GroupingIcon.vue'
import {shortUuid} from '../../../../utils/uuid'

export default {
  name: 'WordTag',
  components: { AnimatedText, GroupingIcon },
  props: {
    text: {default: null, type: Array},
    selected: {default: true, type: Boolean},
    disabled: {default: false, type: Boolean},
    color: {default: 'orange', type: String, validator: (value) => ['orange', 'blue'].includes(value)},
    animated: {default: true, type: Boolean}
  },
  methods: {
    generateUuid () {
      return '-' + shortUuid()
    }
  }
}
</script>

<style scoped lang="scss">
.word-tag {
  &-container {
    border-radius: 8px;
    border: $length-small-s solid $grey-500;
    padding: 2px 5px;
    margin: 3px;
    min-width: min-content;
    cursor: pointer;
    max-width: fit-content;
    opacity: .5;
    &-orange {
      border: unset;
      background-color: $warning-400;
      opacity: 1;
    }
    &-blue {
      background-color: $light-blue-400;
      opacity: 1;
    }
  }
  &-dot {
    display: inline-block;
    width: 5px;
    aspect-ratio: 1;
    border-radius: 50%;
    background-color: $grey-800;
    &-selected {
      background-color: $warning-500;
    }
  }
  &-text {
    margin: 0;
    &-container {
      margin: 0 5px;
      text-wrap: nowrap;
      &-orange {
        color: $warning;
      }

      &-blue {
        color: $blue-primary;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/parts/utils/buttons/WordTag.vue